import { getResultPropKey } from '../utils/getResultPropKey';
import { counter, resultsProps } from './resultProps';
export const withResultObserver = (setProps, options) => functions => {
  const listen = (fn, key) => {
    return async args => {
      var _counter$counterKey;
      let result,
        hasError = false;
      const resultPropKey = getResultPropKey(options == null ? void 0 : options.resultPropName);
      try {
        result = await fn(...(args || []));
      } catch (e) {
        result = e == null ? void 0 : e.message;
        hasError = true;
      }
      const counterKey = resultPropKey + '-' + key;
      counter[counterKey] = ((_counter$counterKey = counter[counterKey]) != null ? _counter$counterKey : 0) + 1;
      resultsProps[resultPropKey] = {
        ...(resultsProps[resultPropKey] || []),
        [key + "Result"]: {
          counter: counter[counterKey],
          value: result,
          hasError
        }
      };
      setProps({
        [getResultPropKey(options == null ? void 0 : options.resultPropName)]: resultsProps[resultPropKey]
      });
    };
  };
  return mapValues(functions, listen);
};
function mapValues(obj, fn) {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = fn(obj[key], key);
    return acc;
  }, {});
}
//# sourceMappingURL=withResultObserver.worker.js.map